// extracted by mini-css-extract-plugin
export var content = "StartCase-module--content--zzx0q";
export var info = "StartCase-module--info--84iV3";
export var label = "StartCase-module--label--lDrOd";
export var title = "StartCase-module--title--PgsN0";